import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

export default function ProductsMegaMenuTabLink({
  tab,
  toggle,
  name,
  link,
  tabId,
  setMegaMenuTab,
  from,
  showNewLabel,
}) {
  const onClick = () => {
    setMegaMenuTab('');
  };

  return (
    <li className="ProductsMegaMenu__link">
      {link ?
        <Link
          to={link}
          tabIndex={0}
          role="menuitem"
          id={`${from}-${tabId}`}
          className={classNames('ProductsMegaMenu__link__tag', { 'ProductsMegaMenu__link__tag--active': tab === `${tabId}` })}
          onMouseEnter={() => toggle(`${tabId}`)}
          onClick={onClick}
        >
          {name}
        </Link>
        :
        <span
          tabIndex={0}
          role="menuitem"
          id={`${from}-${tabId}`}
          className={classNames('ProductsMegaMenu__link__tag', { 'ProductsMegaMenu__link__tag--active': tab === `${tabId}` })}
          onMouseEnter={() => toggle(`${tabId}`)}
          onClick={onClick}
        >
          {name}
        </span>
      }

      {showNewLabel &&
        <div className="ProductsMegaMenu__link__label">
          <FormattedMessage
            id="ProductsMegaMenuTabLink.label.new"
            defaultMessage="New"
          />
        </div>
      }
    </li>
  );
}

ProductsMegaMenuTabLink.propTypes = {
  tab: PropTypes.string,
  toggle: PropTypes.func,
  name: PropTypes.string,
  link: PropTypes.string,
  tabId: PropTypes.string,
  setMegaMenuTab: PropTypes.func,
  from: PropTypes.string.isRequired,
  showNewLabel: PropTypes.bool,
};

ProductsMegaMenuTabLink.defaultProps = {
  tab: '1',
  toggle: () => {},
  name: '',
  tabId: '1',
  link: null,
  setMegaMenuTab: () => {},
  showNewLabel: false,
};
